module.exports = __webpack_public_path__ + "static/media/NORMA Y REGLAMENTOS EIDEFUT.a1f4e444.pdf";